import React,{ Component } from 'react';

import {
  Button
} from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validateThisOrThatEngagement } from '../../../shared/validators';

class CampaignThisOrThatForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{options:[]},
      thisImage:null,
      thatImage:null
    };
  }

  componentDidMount(){
    if(this.props.activeEngagementFirstImageURL && this.props.activeEngagementFirstImageFileName){
      this.setState({thisImage:{
        id:this.props.activeEngagementFirstImageId,
        fileName:this.props.activeEngagementFirstImageFileName,
        large:this.props.activeEngagementFirstImageURL
      }});
    }

    if(this.props.activeEngagementSecondImageURL && this.props.activeEngagementSecondImageFileName){
      this.setState({thatImage:{
        id:this.props.activeEngagementSecondImageId,
        fileName:this.props.activeEngagementSecondImageFileName,
        large:this.props.activeEngagementSecondImageURL
      }});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const {thisImage,thatImage} = this.state;

    data.tags = (data.firstTags || []).concat(data.secondTags || []);

    if(thisImage){
      data.firstImageId = thisImage.id;
      data.firstImageFileName = thisImage.fileName;
      data.firstImageURL = thisImage.large;
    }

    if(thatImage){
      data.secondImageId = thatImage.id;
      data.secondImageFileName = thatImage.fileName;
      data.secondImageURL = thatImage.large;      
    }

    const validationMessages = validateThisOrThatEngagement(data);

    console.log('VALIDATION = ',validationMessages);

    delete data.firstTags;
    delete data.secondTags;

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target={`ThisImageInput_${this.props.activeEngagementId}`}
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='"This or That" Activity'
        >
          <p>
            Give consumers two image options to quickly select from.  The speed of the activity can expose hard-to-articulate preferences.
            <br /><br />
            Suggestions:<br />
            Reveal consumer preferences<br />
            Reveal consumer demographics
          </p>
        </TutorialPopover>
        <HiddenInput name='id' value={this.props.activeEngagementId} />
        <DroppableFileInput
          id={`ThisImageInput_${this.props.activeEngagementId}`}
          label='"This" image'
          text='Upload This image'
          name='firstImage'
          warning={this.state.validationMessages['firstImageURL']}
          onChange={(image) => this.setState({thisImage:image})}
          cropperAspectRatio={4/3}
          existingFileName={this.props.activeEngagementFirstImageFileName}
          existingFileURL={this.props.activeEngagementFirstImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.  <br />Maximum file size of 2MB.</span>
          )}
        />
        <TextInput
          label='Title'
          name='firstImageTitle'
          defaultValue={this.props.activeEngagementFirstImageTitle}
          placeholder='Apples'
          warning={this.state.validationMessages['firstImageTitle']}
          maxLength={30}
        />
        <DCMTagInput 
          type='first' 
          name='firstTags'
          defaultValue={this.props.activeEngagementFirstTags}
          warning={this.state.validationMessages['firstTags']}
        />
        <br />
        <hr />
        <DroppableFileInput
          label='"That" image'
          text='Upload That image'
          name='secondImage'
          warning={this.state.validationMessages['secondImageURL']}
          onChange={(image) => this.setState({thatImage:image})}
          cropperAspectRatio={4/3}
          existingFileName={this.props.activeEngagementSecondImageFileName}
          existingFileURL={this.props.activeEngagementSecondImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.  <br />Maximum file size of 2MB.</span>
          )}
        />
        <TextInput
          label='Title'
          name='secondImageTitle'
          defaultValue={this.props.activeEngagementSecondImageTitle}
          placeholder='Oranges'
          warning={this.state.validationMessages['secondImageTitle']}
          maxLength={30}
        />
        <DCMTagInput 
          type='second' 
          name='secondTags'
          defaultValue={this.props.activeEngagementSecondTags}
          warning={this.state.validationMessages['secondTags']}
        />
        <br />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignThisOrThatForm.defaultProps = {
  isShowingTutorial:true
};

export default CampaignThisOrThatForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignThisOrThatForm.js